import { Thank } from '../../../types/thank';
import { ApiAbstract } from '../abstract';

export class ApiThank extends ApiAbstract<Thank, any> {}